// extracted by mini-css-extract-plugin
export default {"gpa__back_to_top":"BackToTop_gpa__back_to_top__jkz+0","gpa__dark_mode":"BackToTop_gpa__dark_mode__3+J7f","gpa__back_to_top_icon":"BackToTop_gpa__back_to_top_icon__RG8AB"};